export const crosshairPlugin = {
    id: 'customCrosshair',
    afterEvent(chart, args) {
        const isActive = chart.options.plugins?.customCrosshair?.enabled ?? false;
        if (!isActive) return;

        const { event } = args;
        const {
            chartArea,
            scales: { y },
        } = chart;
        const stepSize = chart.options.plugins.customCrosshair.stepSize ?? 1;

        // Clear guide when pointer leaves the chart
        if (event.type === 'mouseout' || event.type === 'mouseleave') {
            chart.crosshair = null;
            chart.draw();
            return;
        }

        if (event.type === 'mousemove') {
            const mouseY = event.y;
            if (mouseY < chartArea.top || mouseY > chartArea.bottom) {
                chart.crosshair = null;
                chart.draw();
                return;
            }
            const rawValue = y.getValueForPixel(mouseY);
            const roundedValue = Math.round(rawValue / stepSize) * stepSize;
            chart.crosshair = { yPixel: mouseY, yValue: roundedValue };
            chart.draw();
        }
    },

    afterDraw(chart) {
        if (!chart.crosshair) return;
        const { ctx, chartArea } = chart;
        const { yPixel, yValue } = chart.crosshair;
        const stepSize = chart.options.plugins.customCrosshair.stepSize ?? 1;
        const unit = chart.options.plugins.customCrosshair.unit ?? '';

        // Draw dashed guide line
        ctx.save();
        ctx.beginPath();
        ctx.setLineDash([5, 5]);
        ctx.moveTo(chartArea.left, yPixel);
        ctx.lineTo(chartArea.right, yPixel);
        ctx.strokeStyle = 'rgba(0,0,0,0.5)';
        ctx.lineWidth = 1;
        ctx.stroke();
        ctx.setLineDash([]);

        // Use one decimal only when stepSize is fractional
        const decimals = Number.isInteger(stepSize) ? 0 : 1;
        let text = yValue.toFixed(decimals);
        if (unit) text = `${text} ${unit}`;

        // Draw label box
        ctx.font = 'bold 12px Arial';
        const padding = 6;
        const textWidth = ctx.measureText(text).width;
        const boxWidth = textWidth + padding * 2;
        const boxHeight = 20;
        const boxX = chartArea.left + 5;
        const boxY = yPixel - boxHeight / 2;

        ctx.fillStyle = '#000';
        ctx.fillRect(boxX, boxY, boxWidth, boxHeight);
        ctx.fillStyle = '#fff';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, boxX + padding, yPixel);
        ctx.restore();
    },
};
